module.exports = __webpack_public_path__ + "assets/img/cancel.00d6c5ae.png";